module.exports = __webpack_public_path__ + "img/icon-check.2e1f9c6d.svg";